/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { parseDate } from '@global/helpers';
import * as Layout from '@components/screen/Layout';
import Table from '@components/table/Table';
import ModalHalf from '@components/modal/ModalHalf';
import ItemDetail from '@components/global/ItemDetail';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import StatusBadge from '@components/global/StatusBadge';

import { MsOrder } from '@api/ms-order';

const tableStructure = {
  name: {
    head: 'Delivery Document Number',
    body: 'name',
    textStyle: { fontFamily: 'figtree-medium' },
  },
  scheduled_date: {
    head: 'Schedule Date',
    body: 'scheduled_date',
    type: 'date',
  },
  effective_date: {
    head: 'Effective Date',
    body: 'effective_date',
    type: 'date',
  },
  source_document: {
    head: 'Source Document',
    body: 'source_document',
  },
  carrier: {
    head: 'Carrier',
    body: 'carrier',
  },
  status: {
    head: 'Status',
    type: 'status',
    body: 'status',
  },
};

const iconSize = {
  width: 23,
  height: 16,
};

const SalesOrderDeliveryScreen = (props) => {
  const [loading, setLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [total, setTotal] = useState(0);
  const [tableData, setTableData] = useState([]);

  const getInvoiceDelivery = async (id) => {
    setLoading(true);
    const response = await MsOrder.getSalesOrderInvoiceDelivery(id);
    if (response?.data?.data?._id) {
      const data = response.data.data;
      const result = data?.deliveries?.length ? data.deliveries : [];
      setTotal(result.length);
      setTableData(result);
    }
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setDetailData({});
      setTotal(0);
      setTableData([]);
      if (props?.route?.params?.salesOrderId) {
        getInvoiceDelivery(props.route.params.salesOrderId);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  return (
    <Layout.Container testID="sales-order-delivery-screen">
      {isWeb ? (
        <>
          <Layout.Back
            title={props.route.params.reference}
            onCallback={() =>
              props.navigation.navigate(
                'SalesOrderDetailScreen',
                props.route.params,
              )
            }
          />
          <Layout.Title title={`Deliveries (${total})`} />

          <Table
            testID="sales-order-delivery-web-table"
            name="sales-order-delivery"
            structures={tableStructure}
            data={tableData}
            loading={loading}
            showSearch={false}
            showFilter={false}
            showPagination={false}
            hasCallback={true}
            hasNoHide={true}
            onClickRow={({ data }) => {
              setShowDetail(true);
              setDetailData(data);
            }}
          />
        </>
      ) : (
        <ScrollView contentContainerStyle={{ width: '100%' }}>
          {loading ? (
            <Layout.Loader />
          ) : !loading && !tableData?.length ? (
            <View
              style={{
                width: '100%',
                paddingHorizontal: 15,
                paddingVertical: 25,
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <SociollaText style={{ fontSize: 13 }}>
                No data found
              </SociollaText>
            </View>
          ) : (
            tableData.map((item, idx) => (
              <TouchableOpacity
                testID={`sales-order-delivery-list-item-${idx}`}
                activeOpacity={0.6}
                style={styles.orderItem}
                onPress={() => {
                  setShowDetail(true);
                  setDetailData(item);
                }}
                key={idx}>
                <View
                  style={[
                    styles.orderItemSection,
                    { alignItems: 'flex-start', marginBottom: 15 },
                  ]}>
                  <View style={styles.itemText}>
                    <SociollaText style={styles.titleItem}>
                      Delivery Document Number:
                    </SociollaText>
                    <SociollaText type="medium" style={{ fontSize: 16 }}>
                      {item.name ? item.name : '-'}
                    </SociollaText>
                  </View>
                  <StatusBadge status={item.status} />
                </View>
                <View style={[styles.orderItemSection, { marginBottom: 15 }]}>
                  <View style={[styles.itemText, styles.itemTextRow]}>
                    <SociollaText style={styles.titleItem}>
                      Schedule Date:
                    </SociollaText>
                    <View style={styles.itemDate}>
                      <Image
                        style={styles.itemDateIcon}
                        width={iconSize.width}
                        height={iconSize.height}
                        svg={true}
                        source={require('@assets/img/icons/menu/calendar.svg')}
                      />
                      <SociollaText
                        style={[styles.itemDesc, { color: Colors.grey2 }]}>
                        {item.scheduled_date
                          ? parseDate(item.scheduled_date)
                          : '-'}
                      </SociollaText>
                    </View>
                  </View>
                  <View style={styles.itemRight}>
                    <SociollaText style={styles.titleItem}>
                      Source Document:
                    </SociollaText>
                    <SociollaText type="medium" style={styles.itemDesc}>
                      {item.source_document ? item.source_document : '-'}
                    </SociollaText>
                  </View>
                </View>
                <View style={styles.orderItemSection}>
                  <View style={[styles.itemText, styles.itemTextRow]}>
                    <SociollaText style={styles.titleItem}>
                      Effective Date:
                    </SociollaText>
                    <View style={styles.itemDate}>
                      <Image
                        style={styles.itemDateIcon}
                        width={iconSize.width}
                        height={iconSize.height}
                        svg={true}
                        source={require('@assets/img/icons/menu/calendar.svg')}
                      />
                      <SociollaText
                        style={[styles.itemDesc, { color: Colors.grey2 }]}>
                        {item.effective_date
                          ? parseDate(item.effective_date)
                          : '-'}
                      </SociollaText>
                    </View>
                  </View>
                  <View style={styles.itemRight}>
                    <SociollaText style={styles.titleItem}>
                      Carrier:
                    </SociollaText>
                    <SociollaText type="medium" style={styles.itemDesc}>
                      {item.carrier ? item.carrier : '-'}
                    </SociollaText>
                  </View>
                </View>
              </TouchableOpacity>
            ))
          )}
        </ScrollView>
      )}

      <ModalHalf
        title={detailData.name}
        visible={showDetail}
        maxWidth={isWeb ? 400 : '100%'}
        onClose={() => {
          setShowDetail(false);
          setDetailData({});
        }}
        children={
          <ScrollView
            contentContainerStyle={{ width: '100%', paddingHorizontal: 15 }}>
            <ItemDetail
              name="Schedule Date"
              value={
                detailData.scheduled_date
                  ? parseDate(detailData.scheduled_date)
                  : '-'
              }
            />
            <ItemDetail
              name="Effective Date"
              value={
                detailData.effective_date
                  ? parseDate(detailData.effective_date)
                  : '-'
              }
            />
            <ItemDetail
              name="Carrier"
              value={detailData.carrier ? detailData.carrier : '-'}
            />
            <ItemDetail
              name="Service Level %"
              value={`${detailData.service_level || 0}%`}
            />
            <ItemDetail
              name="Responsible Person"
              value={
                detailData.responsible_person
                  ? detailData.responsible_person
                  : '-'
              }
            />
            <ItemDetail
              name="Delivery Status"
              centered
              withoutBorder={true}
              value={<StatusBadge status={detailData.status} />}
            />
          </ScrollView>
        }
      />
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  orderItem: {
    width: '100%',
    paddingVertical: 20,
    paddingHorizontal: 10,
    backgroundColor: Colors.white,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  orderItemSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  titleItem: {
    fontSize: 12,
    marginBottom: 5,
    color: Colors.grey2,
  },
  itemText: {
    marginRight: 10,
  },
  itemDate: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemDateIcon: {
    width: iconSize.width,
    height: iconSize.height,
    marginLeft: -5,
    marginRight: 3,
  },
  itemRight: {
    width: '45%',
  },
  itemTextRow: {
    width: '45%',
    borderRightWidth: 1,
    borderRightColor: Colors.grey0,
  },
  itemDesc: {
    fontSize: 14,
  },
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 15,
    marginBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  detailItemLeft: {
    width: 120,
    fontSize: 13,
    color: Colors.grey1,
  },
  detailItemRight: {
    fontSize: 14,
  },
});

export default SalesOrderDeliveryScreen;
